import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
    FormDataConsumer,
} from 'react-admin';
import ResourceTypesInput from './ResourceTypesInput';

const ResourceCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" validate={required()} />
            <TextInput source="slug" validate={required()} />
            <ReferenceInput label="Environment" source="environment_id" reference="environments">
                <SelectInput source="name" validate={required()} />
            </ReferenceInput>
            <ResourceTypesInput source="type" validate={required()} />

            <FormDataConsumer>
                {({ formData, ...rest }) => {
                    if (formData.type === "azure_storage") {
                        return (
                            <ReferenceInput label="Azure storage" source="azure_storage_id" reference="azure_storages">
                                <SelectInput optionText="account_name" optionValue="id" allowEmpty />
                            </ReferenceInput>
                        );
                    } else if (formData.type === "mysql" || formData.type === "postgres") {
                        return (
                            <ReferenceInput label="Database Item" source="database_item_id" reference="database_items">
                                <SelectInput optionText="hostname" optionValue="id" allowEmpty />
                            </ReferenceInput>
                        );
                    } else if (formData.type === "azure_sql") {
                        return (
                            <>
                            <ReferenceInput label="Database Item" source="database_item_id" reference="database_items">
                                <SelectInput optionText="hostname" optionValue="id" allowEmpty />
                            </ReferenceInput>
                            <TextInput source="group_name" />
                            <ReferenceInput label="Azure auth" source="azure_authentication_id" reference="azure_authentications">
                                <SelectInput optionText="name" optionValue="id" allowEmpty />
                            </ReferenceInput>
                            </>
                        );
                    } else if (formData.type === "azure_appservice") {
                        return (
                            <ReferenceInput label="Azure auth" source="azure_authentication_id" reference="azure_authentications">
                                <SelectInput optionText="name" optionValue="id" allowEmpty />
                            </ReferenceInput>            
                        );
                    }
                }}
            </FormDataConsumer>

        </SimpleForm>
    </Create>
);

export default ResourceCreate;